<template>
  <modal name="addplayermodal"
         :resizable="true" 
         :adaptive="true" 
         :scrollable="true"
         :height="'auto'"
         @before-open="beforeOpen"
         @before-close="beforeClose">
<!--     <div slot="top-right">
      <button @click="$modal.hide('addplayermodal')">
        ❌
      </button>
    </div> -->
    <div v-if="playerAdded" class="mdl-grid center-items">
      <div class="mdl-cell mdl-cell--10-col center-items">
        <div><span><b>{{action}}ed: </b> {{newPlayer.name}}!</span></div>
        <div class="mdl-dialog__actions">
          <button type="button" class="mdl-button close" @click="$modal.hide('addplayermodal')">Close</button>
        </div>
      </div>
    </div>
    <div v-else-if="needDrop" class="mdl-grid center-items">
      <div class="mdl-cell mdl-cell--10-col center-items">
        <div><span><b>{{action}}ing: </b> {{newPlayer.name}}, {{newPlayer.position}}, {{newPlayer.team}}</span></div>
        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder" >
          <select class="mdl-textfield__input form-control" v-model="playerToDrop" :required="true">
            <option v-for="(p,key) of players" v-bind:value="key">{{key}}: {{ p }}</option>
          </select>
          <label class="mdl-textfield__label" for="viewStatsSelect">Select player to drop</label>
        </div>
      </div>
      <div v-if="playerToDrop!='undefined'" class="mdl-cell mdl-cell--10-col center-items">
        <div><span><b>{{action}}: </b> {{newPlayer.name}}</span></div>
        <div><span><b>Drop:</b> {{players[playerToDrop]}}</span></div>
        <div class="mdl-dialog__actions">
          <button type="button" class="mdl-button" @click="addAndDrop">Confirm</button>
          <button type="button" class="mdl-button close" @click="$modal.hide('addplayermodal')">Close</button>
        </div>
      </div>
    </div>
    <div v-else class="mdl-grid center-items">
      <div class="mdl-cell mdl-cell--10-col center-items">
        <div><span><b>{{action}}: </b> {{newPlayer.name}}, {{newPlayer.position}}, {{newPlayer.team}}</span></div>
        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder" >
          <select class="mdl-textfield__input form-control" v-model="positionForPlayer" :required="true">
            <option v-for="p in eligiblePositionsToAdd" v-bind:value="p">{{ p }}</option>
          </select>
          <label class="mdl-textfield__label" for="viewStatsSelect">Select roster position</label>
        </div>
        <div v-if="positionForPlayer!='undefined'" class="mdl-dialog__actions">
          <button type="button" class="mdl-button" @click="addAndDrop">Confirm</button>
          <button type="button" class="mdl-button close" @click="$modal.hide('addplayermodal')">Close</button>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { db } from '../db'

export default {
  data () {
    return {
      name: "def name",
      newPlayer: {},
      leagueKey: "",
      teamKey: "",
      teamName: "",
      players: null,
      playerToDrop: "undefined",
      positionForPlayer: "undefined",
      needDrop : false,
      playerAdded: false,
      eligiblePositionsToAdd: [],
      action: "Claim",
      userUID: "null",
    }
  },
  firebase: {
    batters: db.ref('batters/'),
  },
  computed: {

  },
  methods: {
    async beforeOpen (event) {
      this.newPlayer = event.params.newPlayer
      this.leagueKey = event.params.leagueKey
      this.teamKey = event.params.teamKey
      this.action = event.params.action
      this.userUID = event.params.userUID
      // Set the opening time of the modal
      let tmpP = this.players
      await db.ref('/leagues/'+this.leagueKey+'/teams/'+this.teamKey+'/players/').once('value',function(snapshot){
        tmpP = snapshot.val()
      })
      this.players = tmpP
      this.needDrop = this.dropNeeded()
      this.teamName = "Unknown Team"
      let snap = await db.ref('/leagues/'+this.leagueKey+'/teams/'+this.teamKey+'/teamName').once('value')
      if (snap.exists()){
        this.teamName = snap.val()
      }
    },
    beforeClose (event) {
      this.playerAdded = false
      this.name= "def name"
      this.newPlayer= {}
      this.leagueKey= ""
      this.teamKey= ""
      this.players= null
      this.playerToDrop= "undefined"
      this.needDrop = false
      this.eligiblePositionsToAdd = []
      this.positionForPlayer = "undefined"
      this.action = "Claim"
      this.userUID = "null"
    },
    dropNeeded() {
      if (this.newPlayer.position == "LHP" || this.newPlayer.position == "RHP" || this.newPlayer.position == "P"){
        let a = this.checkPositionStatus('pitcher1','P1')
        let b = this.checkPositionStatus('pitcher2','P2')
        let c = this.checkPositionStatus('pitcher3','P3')
        let d = this.checkPositionStatus('pitcher4','P4')
        let e = this.checkPositionStatus('pitcher5','P5')
        let f = this.checkPositionStatus('pitcher6','P6')
        return a&&b&&c&&d&&e&&f
      }  
      
      let retVal = true
      retVal = this.checkPositionStatus('dh','DH')

      if (this.newPlayer.position == "OF"){
        let a = this.checkPositionStatus('outfield1','OF1')
        let b = this.checkPositionStatus('outfield2','OF2')
        let c = this.checkPositionStatus('outfield3','OF3')
        return  a &&  b && c && retVal
      } else {
        switch (this.newPlayer.position) {
          case "1B":
            return this.checkPositionStatus('first','1B') && retVal
          case "2B":
            return this.checkPositionStatus('second','2B') && retVal
          case "3B":
            return this.checkPositionStatus('third','3B') && retVal
          case "SS":
            return this.checkPositionStatus('shortstop','SS') && retVal
          case "C":
            return this.checkPositionStatus('catcher','C') && retVal
          default:
            // console.log("Default: "+this.newPlayer.position)
            return retVal
        }
      }
      return retVal
    },
    async addAndDrop() {
      let dropPlayerName = "No drop necessary" 
      let dropPlayerPos = "" 
      let positionToUpdate = this.playerToDrop

      if (positionToUpdate == 'undefined'){
        positionToUpdate = this.positionForPlayer
      }
      else{
        let snapshot = null

        if ((this.newPlayer.position == "LHP" || this.newPlayer.position == "RHP" || this.newPlayer.position == "P")){
          snapshot = await db.ref('pitchers/players/'+this.players[positionToUpdate]).once('value')
        } else {
          snapshot = await db.ref('batters/players/'+this.players[positionToUpdate]).once('value')
        }

        if (snapshot.exists()){
          dropPlayerName = snapshot.val().name
          dropPlayerPos = snapshot.val().position
          // console.log("Player to drop is: "+dropPlayerName+' '+dropPlayerPos)
        }
      }

      if(this.canDrop() || !this.needDrop){
        if (this.action == "Add" || this.action == "Draft"){

          db.ref('/leagues/'+this.leagueKey+'/teams/'+this.teamKey+'/players/'+positionToUpdate).set(this.newPlayer.link.split('players/')[1])

          let addSummary = this.teamName+' '+ this.action+'ed '+this.newPlayer.name+'. '
          if (this.action == "Add"){
            addSummary = this.teamName+' added '+this.newPlayer.position+' '+this.newPlayer.name+'. Dropped '+dropPlayerPos+' '+dropPlayerName
          } else {
            addSummary = this.teamName+' drafted '+this.newPlayer.position+' '+this.newPlayer.name+'. '
          }

          if ((this.newPlayer.position == "LHP" || this.newPlayer.position == "RHP" || this.newPlayer.position == "P")) {
            db.ref('pitchers'+this.newPlayer.link+'/owners/'+this.leagueKey).set(this.teamKey)
            if (this.playerToDrop != 'undefined')
              db.ref('pitchers/players/'+this.players[positionToUpdate]+'/owners/'+this.leagueKey).set('FreeAgent')
          } else {
            db.ref('batters'+this.newPlayer.link+'/owners/'+this.leagueKey).set(this.teamKey)
            if (this.playerToDrop != 'undefined')
              db.ref('batters/players/'+this.players[positionToUpdate]+'/owners/'+this.leagueKey).set('FreeAgent')
          }

          // console.log(addSummary)
          let transaction = {
            teamKey: this.teamKey,
            summary: addSummary,
            date: Date.now()
          }
          db.ref('transactions/'+this.leagueKey).push(transaction)
          
        } else if (this.action == "Claim"){

          let claim = {
            addPlayerName : this.newPlayer.name,
            addPlayerLink : this.newPlayer.link,
            addPosition : positionToUpdate,
            dropPlayerLink : (this.playerToDrop == 'undefined') ? 'nodrop' : "/players/"+this.players[positionToUpdate],
            dropPlayerName: dropPlayerName,
            date : Date.now(),
            status: "pending"
          }
          db.ref('/claims/'+this.leagueKey+'/'+this.teamKey+'/'+this.userUID).push(claim)
        }

        this.playerAdded = true

      } else {
        alert("Invalid Option. Can't drop "+this.playerToDrop+" while adding "+this.newPlayer.position)
      }
      
    },
    canDrop(){
      let droppedPosition = this.playerToDrop
      if (this.newPlayer.position == "LHP" || this.newPlayer.position == "RHP" || this.newPlayer.position == "P"){
        return droppedPosition=='pitcher1' || droppedPosition=='pitcher2' || droppedPosition=='pitcher3' || droppedPosition=='pitcher4' || droppedPosition=='pitcher5' || droppedPosition=='pitcher6'
      } else if (this.newPlayer.position == "OF"){
        return droppedPosition=='outfield1' || droppedPosition=='outfield2' || droppedPosition=='outfield3' || droppedPosition=='dh'
      } else if (this.newPlayer.position == "1B"){
        return droppedPosition=='first' || droppedPosition=='dh'
      } else if (this.newPlayer.position == "2B"){
        return droppedPosition=='second' || droppedPosition=='dh'
      } else if (this.newPlayer.position == "3B"){
        return droppedPosition=='third' || droppedPosition=='dh'
      } else if (this.newPlayer.position == "SS"){
        return droppedPosition=='shortstop' || droppedPosition=='dh'
      } else if (this.newPlayer.position == "C"){
        return droppedPosition=='catcher' || droppedPosition=='dh'
      } else if (this.newPlayer.position == "DH"){
        return droppedPosition=='dh'
      }
      console.log("Hmmm, what postion are we trying to drop: "+droppedPosition)
      return false
    },
    checkPositionStatus(pos,posString){
      if (this.players && this.players[pos] && this.players[pos]!=""){
        return true
      } else {
        this.eligiblePositionsToAdd.push(pos);
        return false
      }
    }
    
  },
}
</script>


// WEBPACK FOOTER //
// src/components/AddPlayerModal.vue